// extracted by mini-css-extract-plugin
var _1 = "t2tk";
var _2 = "t2tl";
export { _1 as "line", _2 as "placeholder" }
